import { render, staticRenderFns } from "./Retrospective.vue?vue&type=template&id=60b64858&scoped=true&"
import script from "./Retrospective.vue?vue&type=script&lang=ts&"
export * from "./Retrospective.vue?vue&type=script&lang=ts&"
import style0 from "./Retrospective.vue?vue&type=style&index=0&id=60b64858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b64858",
  null
  
)

export default component.exports